export enum PaperReceiptMode {
  Always = 'Always',
  OnDemand = 'OnDemand',
  Never = 'Never',
}
